/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import ic_lock from "../../assets/images/pictures/icon/ic_outline-lock-64px.svg";
import ic_gdpr from "../../assets/images/pictures/icon/ic_gdpr-64px.svg";
import ic_oval_lock from "../../assets/images/pictures/icon/ic_oval-baseline-lock-24px.svg";

import ic_hammer from "../../assets/images/pictures/icon/ic_hammer.svg";
import group from "../../assets/images/pictures/compliance-content-1.png";
import iso_ias from "../../assets/images/compliance/iso-ias-new.png";

import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";
import ic_arrow_left from "../../assets/images/pictures/icon/ic_arrow_left.svg";

import ic_plus from "../../assets/images/pictures/icon/ic_plus.svg";
import ic_sub from "../../assets/images/pictures/icon/ic_subtraction.svg";

import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ComplianceContent = () => {
  const { i18n } = useTranslation();
  const [openTerms, setOpenTerms] = useState(false);
  const [openPrivacy, setOpenPrivacy] = useState(false);

  const [openDPA, setOpenDPA] = useState(false);

  const handleOpenTermOfService = () => {
    setOpenTerms((prev) => !prev);
    setOpenPrivacy(false);
    setOpenDPA(false);

    document.getElementById("openPrivacyPolicy")?.classList.remove("open");
    document.getElementById("openDPA")?.classList.remove("open");
    document.getElementById("openTermsOfService")?.classList.toggle("open");
  };

  const handleOpenPrivacyPolicy = () => {
    setOpenPrivacy((prev) => !prev);
    setOpenTerms(false);
    setOpenDPA(false);

    document.getElementById("openTermsOfService")?.classList.remove("open");
    document.getElementById("openDPA")?.classList.remove("open");
    document.getElementById("openPrivacyPolicy")?.classList.toggle("open");
  };

  const handleOpenDPA = () => {
    setOpenDPA((prev) => !prev);
    setOpenTerms(false);
    setOpenPrivacy(false);

    document.getElementById("openTermsOfService")?.classList.remove("open");
    document.getElementById("openPrivacyPolicy")?.classList.remove("open");
    document.getElementById("openDPA")?.classList.toggle("open");
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest("#dropdownMenuLinkTerms")) {
        document.getElementById("openTermsOfService")?.classList.remove("open");
        setOpenTerms(false);

        document.getElementById("openPrivacyPolicy")?.classList.remove("open");
        setOpenPrivacy(false);

        document.getElementById("openDPA")?.classList.remove("open");
        setOpenDPA(false);
      }
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  const language = useSelector(selectLanguage);

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      {language === "en" ? (
        <div className="compliance">
          <div className="container-fuild background-compliance-image">
            <h1 className="compliance-gopaperless text-center mx-auto pt-60">
              GOPAPERLESS
            </h1>
            <div className="container">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <h2 className="font-weight-bold text-yellow font-60">
                    We Take Things Seriously
                  </h2>
                  <p className="mb-25 mt-25 text-white">
                    At GoPaperless, we are committed to maximum data security
                    and adherence to regulations. As transparency is one of the
                    principles our company is built on, we aim to be as clear
                    and open as we can about the way we handle security and
                    compliance. Don’t rely on clumsy solutions, your business is
                    not a joke.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container pt-50">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center">
                <img
                  width="64"
                  height="64"
                  src={ic_lock}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="font-weight-bold">Information security</h2>
                <p>
                  Our business operations, internal systems, development and
                  support processes comply with ISO/IEC 27001:2022 — the
                  internationally recognised standard for leading information
                  security management practices.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-10 col-lg-offset-1">
                <div className="row panel-box m-md-0">
                  <div className="col-sm-12 col-md-4 text-center">
                    <img
                      width="200"
                      height="93"
                      src={iso_ias}
                      className="img-responsive"
                      alt=""
                      decoding="async"
                      loading="lazy"
                    />
                    <a
                      // href="/uploads/Certificate-ISO-2700-2022-Mobile-ID-20241209"
                      href="https://mobile-id.vn/uploads/Mobile-ID-ISO-27001-2022-Certification"
                      target="_blank"
                      rel="noreferrer"
                      className="iso btn-primary btn-primary--mini"
                    >
                      View certificate
                    </a>
                  </div>
                  <div className="col-sm-12 col-md-8">
                    <div className="p-r">
                      <p>
                        We are being audited annually by the auditing company
                        SISCERT regarding our activities, and we have certified
                        our implemented Information Security Management System
                        (ISMS) with the scope of certification being “Solutions
                        for digital identity, secure authentication and digital
                        signing -Trusted Hub, GoPaperless, Mobile-ID, CheckID,
                        Facial Sense, Trusted Pay, Trusted Care, TrustedID,
                        Trusted Kioware, X-Avenue, MRConnect, Qrypto, Blockchain
                        Services Infrastructure, Remote Signing, Time-Stamping
                        Authority, PKI tokens, eID cards and ePassport
                        certificates.”.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-60 bg-color">
            <div className="overlay gdpr">
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 pl-0">
                    <img
                      width="64"
                      height="64"
                      src={ic_gdpr}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h2 className="font-weight-bold">Law compliance</h2>
                    <p>
                      We are committed to protecting your personal data.&nbsp;
                      <br />
                      <a
                        href="/uploads/356nd-signed"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Decree 356/2025/NĐ-CP
                      </a>
                      &nbsp; is considered the best framework to comply with
                      Personal Data Protection and includes almost all the
                      necessary requirements according to legal regulations. In
                      addition, we have integrated all necessary control
                      measures and procedures arising from legal regulations
                      into our Information Security Management System.
                    </p>
                  </div>
                  <div className="col-sm-6 panel-box">
                    <div className="text-box"></div>
                    <div className="text-box">
                      <img
                        width="24"
                        height="24"
                        src={ic_oval_lock}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p>
                        We give you full control over all your data and provide
                        means to manage it via both the user-friendly interface
                        and developer-friendly API.
                      </p>
                    </div>
                    <div className="text-box">
                      <img
                        width="24"
                        height="24"
                        src={ic_oval_lock}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p>
                        You can find information about what data we collect in
                        our&nbsp;
                        <Link
                          to={
                            language === "vi"
                              ? "/uploads/GoPaperless-ChinhSachBaoMatThongTin"
                              : "/uploads/GoPaperless-InformationSecurityPolicy"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          Privacy Policy
                        </Link>
                        . You can find our&nbsp;
                        <Link
                          to={
                            language === "vi"
                              ? "/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
                              : "/uploads/GoPaperless-PersonalDataCollectionProccessPolicy"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          Personal data collection and processing policy here
                        </Link>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="container pt-50">
              <div className="row text-center">
                <div className="col-sm-8 col-sm-offset-2">
                  <img
                    width="64"
                    height="64"
                    src={ic_outline_group}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold">
                    Rigorously chosen service providers
                  </h2>
                  <p>
                    We work only with those service providers to which security
                    is a top priority. Each of our business partner is chosen
                    after a rigorous due-diligence process and closely monitored
                    by our Security Team. Some of our business partners process
                    your information on our behalf in compliance with our
                    Privacy Policy. We ensure that all our data shall be
                    processed within the EU/EEA.
                  </p>
                </div>
                <div className="col-sm-4 logo-box">
                  <img src={skid_solution} alt="" />
                </div>
                <div className="col-sm-4 logo-box">
                  <img src={audkenni} alt="" />
                </div>
                <div className="col-sm-4 logo-box">
                  <img src={amazon} alt="" />
                </div>
                <div className="col-sm-12 mt-20 ">
                  <p className="mx-auto">
                    You can find these business partners in our{" "}
                    <a href="/compliance/list-of-subprocessors" rel="noopener">
                      list of sub-processors
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div> */}
          </div>

          {/* <div className="container-fuild bg-primary">
            <div className="container eidas">
              <div className="row pb-16">
                <div className="col-sm-8 col-sm-offset-2 text-center">
                  <img
                    width="64"
                    height="64"
                    src={ic_eidas}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold text-white">
                    eIDAS compliance
                  </h2>
                  <div className="sub">
                    <p className="text-white">
                      Electronic signatures are not scribbled images on a
                      document. Don’t lose out because of clumsy providers in
                      the market that take legal things related to your
                      documents for granted. At GoPaperless, we take things
                      seriously.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6">
                  <img
                    width="41"
                    height="24"
                    src={ic_all_seals}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <p className="text-white">
                    We have been developing our services from the ground up
                    according to all the technical requirements of Regulation
                    (EU) №910/2014 (eIDAS). Our services work only with
                    Qualified Certificates, meaning that each signature produced
                    with our help is uniquely and unambiguously linked to both
                    the signer and the data signed. It is practically impossible
                    to fake such a signature or re-use it with a different or
                    modified document. To top that off, we also back up each
                    signature with a Qualified Timestamp, thus providing legal
                    proof about the time it was produced.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img
                    width="41"
                    height="24"
                    src={ic_all_seals}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <p className="text-white">
                    All signatures produced with the help of our services meet
                    the requirements for Qualified Electronic Signatures or
                    Advanced Electronic Signatures set forth under the eIDAS
                    regulation. These signatures are accepted across the EU. We
                    work with eID infrastructures in the EU member countries and
                    support and rely only on Qualified Trust Service Providers
                    listed in the European Union Trusted Service List.
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-10 col-lg-offset-1">
                  <div
                    className="row panel-box bg-color-B1D1F5"
                    style={{ border: "none" }}
                  >
                    <div className="col-sm-12 col-md-4 text-center">
                      <img
                        width="110"
                        src={compliance_logo}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <a
                        href="https://gopaperless.mobile-id.vn/Certificate ISO 2700-2022_Mobile ID_20241209.pdf"
                        target="_blank"
                        rel="noreferrer"
                        className="iso btn-primary btn-primary--mini"
                      >
                        View certificate
                      </a>
                    </div>
                    <div className="col-sm-12 col-md-8">
                      <div className="p-r">
                        <p data-renderer-start-pos="63">
                          GoPaperless is the first Qualified Trust Service
                          Provider for e-signatures and e-seals validation in
                          the Baltics, supervised by a&nbsp;
                          <a
                            className="sc-bHwgHz ezBJcQ"
                            title="https://www.rrt.lt/en/"
                            href="javascript:;"
                            rel="noopener"
                            data-renderer-mark="true"
                          >
                            Member State Supervisory Body
                          </a>
                          &nbsp;and included in the&nbsp;
                          <a
                            className="sc-bHwgHz ezBJcQ"
                            title="https://webgate.ec.europa.eu/tl-browser/#/tl/LT/5"
                            href="javascript:;"
                            rel="noopener"
                            data-renderer-mark="true"
                          >
                            EU Trusted Service List
                          </a>
                          .
                        </p>
                        <p data-renderer-start-pos="265">
                          Learn more about our validation practices and
                          liabilities in our&nbsp;
                          <a
                            className="sc-bHwgHz ezBJcQ"
                            href="javascript:;"
                            rel="noopener"
                            data-renderer-mark="true"
                          >
                            Signature Validation Service Practice Statement and
                            Policy
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="container-fuild bg-color">
            <div className="container service px-md-0">
              <div className="row text-center">
                <div className="col-sm-8 col-sm-offset-2">
                  <img
                    width="64"
                    height="64"
                    src={ic_graphic_eq_gradient}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold">
                    Service availability and business continuity
                  </h2>
                  <p>
                    We have wide experience in supporting business critical
                    processes and thus give careful attention to service
                    availability. We constantly try to improve and invest great
                    effort into securing your business continuity, but don’t
                    just take our word for it — check our status to see for
                    yourself how we measure up.
                  </p>
                </div>
                <div className="col-sm-4">
                  <div className="panel-box bg-white">
                    <img
                      width="30"
                      height="30"
                      src={ic_history}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      Recovery Point Objective (
                      <a href="javascript:;" rel="noopener">
                        RPO
                      </a>
                      )
                    </h4>
                    <p>1 hour</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="panel-box bg-white">
                    <img
                      width="30"
                      height="30"
                      src={ic_history}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      Recovery Time Objective (
                      <a href="javascript:;" rel="noopener">
                        RTO
                      </a>
                      )
                    </h4>
                    <p>2 hour</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="panel-box bg-white">
                    <img
                      width="30"
                      height="30"
                      src={ic_alarm_on}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      Maximum Tolerable Period of Downtime
                      <span className="inner">
                        (
                        <a href="javascript:;" rel="noopener">
                          MTPOD
                        </a>
                        )
                      </span>
                    </h4>
                    <p>4 hours</p>
                  </div>
                </div>

                <div className="container px-md-0">
                  <div className="col-sm-12 panel-box last mt-30 bg-white">
                    <div className="col-sm-4 proved">
                      <img
                        width="30"
                        height="30"
                        src={ic_av_timer}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <h4>Proved Service Availability</h4>
                    </div>
                    <div className="col-sm-4">
                      <p className="sub">
                        <a href="javascript:;">
                          99,95% monthly uptime availability
                        </a>
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img
                        width="331"
                        height="108"
                        src={ic_path}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container mt-80 business">
              <div className="row">
                <div className="col-xs-12 px-md-0">
                  <div className="text-center row">
                    <div className="col-sm-4">
                      <img
                        width="40"
                        height="40"
                        src={ic_enhanced_encryption}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p className="font-weight-bold my-18-12">
                        Strong data encryption and data integrity
                      </p>
                      <p>
                        All our data is encrypted using Transport Layer Security
                        (TLS) and AES-256 encryption algorithm. Data integrity
                        is ensured by mirroring all data in two separate
                        locations. In case of emergency, data and data integrity
                        can be restored from backups with automated procedures
                        wand Recovery Point Objective of 1 hour.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img
                        width="40"
                        height="40"
                        src={ic_outline_security}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p className="font-weight-bold my-18-12">
                        Dedicated security team
                      </p>
                      <p>
                        We have dedicated personnel to manage and monitor all
                        our services and infrastructure 24/7. Our team has an
                        incident management process with contingency plans,
                        incident response playbooks and multiple levels of
                        escalation.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img
                        width="40"
                        height="40"
                        src={ic_outline_bug_report}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />{" "}
                      <p className="font-weight-bold my-18-12">
                        Security vulnerabilities and bug bounties
                      </p>
                      <p>
                        We are committed to employ the best security practices
                        in the industry. If you believe you have discovered a
                        vulnerability in our services, we welcome the
                        contribution of external security researchers and look
                        forward to awarding them for their contribution to the
                        security of all GoPaperless users. Follow the disclosure
                        guidelines defined in our&nbsp;
                        <a href="javascript:;" rel="noopener">
                          Vulnerability Disclosure Policy
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="bg-primary">
            <div className="container insured">
              <div className="row ">
                <div className="col-md-7">
                  <h2 className="font-weight-bold text-white">Fully insured</h2>
                  <div className="sub">
                    <p className="text-white">
                      We are fully insured against professional indemnity,
                      privacy breaches and cyber attacks up to $1M. We hope we
                      won’t have to make use of it but it surely provides extra
                      comfort to us and our customers. We will maintain valid
                      insurance throughout the delivery of our services.
                    </p>
                  </div>
                  <a href="javascript:;" className="btn-primary">
                    View certificate
                  </a>
                </div>

                <div className="col-md-5">
                  <img
                    src={require("../../assets/images/pictures/lloyds.png")}
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div> */}

          <div className="bg-bottom-compliance">
            <div className="container pt-50">
              <div className="row">
                <div className="col-sm-5 px-md-0">
                  <img src={group} className="img-responsive" alt="" />
                </div>
                <div className="col-sm-7 pl-md-70">
                  <h2 className="heading font-weight-bold pb-22">
                    How to choose an e-signing solution provider
                  </h2>
                  <p>
                    When entrusting your company documents to the partners,
                    whether department or company-wide, not only the
                    front-facing part of the signing process matters; everything
                    in the back – compliance with the regulations, qualification
                    of services, information security, actual signature validity
                    – can make all the difference in the world.
                  </p>
                  <p className="pb-16">
                    Be careful who you hand your data over to and beware not to
                    slip on only supposedly declared compliance and hazy
                    statements. Download the checklist to guide you through the
                    most important aspects of choosing an e-signing solution
                    provider.
                  </p>
                  <a href="javascript:;" className="btn-secondary">
                    Download the checklist
                  </a>
                </div>
              </div>
            </div>

            <div className="container legal">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <img
                    width="64"
                    height="64"
                    src={ic_hammer}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 id="legal" className="font-weight-bold">
                    Legal
                  </h2>
                </div>
                <div className="col-sm-12 px-md-0">
                  <ul className="panel-box--list">
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Warning of data sharing revocation from VNeID</span>

                      <div className="dropdown" id="openTermsOfService">
                        <a
                          href="javascript:;"
                          className="mr-32"
                          onClick={handleOpenTermOfService}
                          id="dropdownMenuLinkTerms"
                        >
                          {openTerms === false ? (
                            <img src={ic_plus} alt="" />
                          ) : (
                            <img src={ic_sub} alt="" className="mr--5" />
                          )}
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuLinkTerms"
                        >
                          <Link
                            to={
                              language === "vi"
                                ? "/uploads/GoPaperless-CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeID"
                                : "/uploads/GoPaperless-WarningDataSharingFromVNeID"
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="dropdown-item"
                          >
                            Original document
                          </Link>
                          {/* <a href="/compliance/terms-of-service" className="dropdown-item"  
                                                    >Vietnamese translation</a> */}
                        </div>
                      </div>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Privacy Policy</span>

                      <div className="dropdown" id="openPrivacyPolicy">
                        <a
                          href="javascript:;"
                          className="mr-32"
                          onClick={handleOpenPrivacyPolicy}
                          id="dropdownMenuLinkTerms"
                        >
                          {openPrivacy === false ? (
                            <img src={ic_plus} alt="" />
                          ) : (
                            <img src={ic_sub} alt="" className="mr--5" />
                          )}
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuLinkTerms"
                        >
                          <Link
                            to={
                              language === "vi"
                                ? "/uploads/GoPaperless-ChinhSachBaoMatThongTin"
                                : "/uploads/GoPaperless-InformationSecurityPolicy"
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="dropdown-item"
                          >
                            Original document
                          </Link>
                          {/* <a href="javascript:;" className="dropdown-item"  >Vietnamese translation</a> */}
                        </div>
                      </div>
                    </li>

                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>
                        Personal data collection and processing policy
                      </span>

                      <div className="dropdown" id="openDPA">
                        <a
                          href="javascript:;"
                          className="mr-32"
                          onClick={handleOpenDPA}
                          id="dropdownMenuLinkTerms"
                        >
                          {openDPA === false ? (
                            <img src={ic_plus} alt="" />
                          ) : (
                            <img src={ic_sub} alt="" className="mr--5" />
                          )}
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuLinkTerms"
                        >
                          <Link
                            to={
                              language === "vi"
                                ? "/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
                                : "/uploads/GoPaperless-PersonalDataCollectionProccessPolicy"
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="dropdown-item"
                          >
                            Original document
                          </Link>
                          {/* <a href="javascript:;" className="dropdown-item"  >Vietnamese translation</a> */}
                        </div>
                      </div>
                    </li>
                    {/* <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Cookie Policy</span>
                      <a
                        className="mr-32"
                        href="/compliance/cookie-policy"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li> */}
                    {/* <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Partnership Agreement</span>
                      <a
                        className="mr-32"
                        href="/compliance/partnership-agreement"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>List of Sub-Processors</span>
                      <a
                        className="mr-32"
                        href="/compliance/list-of-subprocessors"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Vulnerability Disclosure Policy</span>
                      <a
                        className="mr-32"
                        href="/compliance/vulnerability-disclosure-policy"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Dispute resolution</span>
                      <a
                        className="mr-32"
                        href="/compliance/dispute-resolution"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>
                        Signature Validation Service Practice Statement and
                        Policy
                      </span>
                      <a
                        className="mr-32"
                        href="/compliance/signature-validation-service-practice-statement-and-policy"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            <div className="border-bottom bg-color p-0">
              <div className="container">
                <div className="row isign-apis">
                  <div className="col-md-5 ">
                    <h2 className="text-get-started">Ready to get started?</h2>
                    <h4 className="text-p">
                      Already a GoPaperless user?{" "}
                      <a
                        href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                          i18n.language || "vi"
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        className="underline"
                      >
                        Log in
                      </a>
                    </h4>
                  </div>
                  <div className="col-sm-12 col-md-7">
                    <div className="btn-box">
                      <a
                        href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                          i18n.language || "vi"
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-secondary"
                      >
                        Start signing — it's free
                      </a>
                      <a href="/features" className="btn-primary ">
                        Why GoPaperless?
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="compliance">
          <div className="container-fuild background-compliance-image">
            <h1 className="compliance-gopaperless text-center mx-auto pt-60">
              GOPAPERLESS
            </h1>
            <div className="container">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <h2 className="font-weight-bold text-yellow font-60">
                    Chúng tôi thực hiện mọi việc một cách nghiêm túc
                  </h2>
                  <p className="mb-25 mt-25 text-white">
                    Tại GoPaperless, chúng tôi cam kết bảo mật dữ liệu tối đa và
                    tuân thủ các quy định. Vì tính minh bạch là một trong những
                    nguyên tắc xây dựng công ty của chúng tôi nên chúng tôi
                    hướng tới sự rõ ràng và cởi mở nhất có thể về cách chúng tôi
                    xử lý vấn đề bảo mật và tuân thủ. Đừng dựa vào những giải
                    pháp vụng về, doanh nghiệp của bạn không phải là trò đùa.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container pt-50">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center">
                <img
                  width="64"
                  height="64"
                  src={ic_lock}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="font-weight-bold">Bảo mật thông tin</h2>
                <p>
                  Hoạt động kinh doanh, hệ thống nội bộ, quy trình phát triển và
                  hỗ trợ của chúng tôi tuân thủ ISO/IEC 27001:2022 — tiêu chuẩn
                  được quốc tế công nhận về các biện pháp quản lý bảo mật thông
                  tin hàng đầu.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-10 col-lg-offset-1">
                <div className="row panel-box m-md-0">
                  <div className="col-sm-12 col-md-4 text-center">
                    <img
                      width="200"
                      height="93"
                      src={iso_ias}
                      className="img-responsive"
                      alt=""
                      decoding="async"
                      loading="lazy"
                    />
                    <a
                      // href="/uploads/Certificate-ISO-2700-2022-Mobile-ID-20241209"
                      href="https://mobile-id.vn/uploads/Mobile-ID-ISO-27001-2022-Certification"
                      target="_blank"
                      rel="noreferrer"
                      className="iso btn-primary btn-primary--mini"
                    >
                      Xem chứng chỉ
                    </a>
                  </div>
                  <div className="col-sm-12 col-md-8">
                    <div className="p-r">
                      <p>
                        Chúng tôi đang được công ty kiểm toán SISCERT kiểm tra
                        hàng năm về hoạt động của mình và chúng tôi đã chứng
                        nhận Hệ thống quản lý bảo mật thông tin (ISMS) đã triển
                        khai của mình với phạm vi chứng nhận là “Solutions for
                        digital identity, secure authentication and digital
                        signing -Trusted Hub, GoPaperless, Mobile-ID, CheckID,
                        Facial Sense, Trusted Pay, Trusted Care, TrustedID,
                        Trusted Kioware, X-Avenue, MRConnect, Qrypto, Blockchain
                        Services Infrastructure, Remote Signing, Time-Stamping
                        Authority, PKI tokens, eID cards and ePassport
                        certificates.”.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-60 bg-color">
            <div className="overlay gdpr">
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 pl-0">
                    <img
                      width="64"
                      height="64"
                      src={ic_gdpr}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h2 className="font-weight-bold">
                      Tuân thủ quy định pháp luật
                    </h2>
                    <p>
                      Chúng tôi cam kết bảo vệ dữ liệu cá nhân của bạn.&nbsp;
                      <br />
                      <a
                        href="/uploads/356nd-signed"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Nghị định 356/2025/NĐ-CP
                      </a>
                      &nbsp; được coi là khuôn khổ tốt nhất để tuân thủ Bảo vệ
                      dữ liệu cá nhân và bao gồm hầu hết tất cả các yêu cầu cần
                      thiết theo quy định pháp luật. Ngoài ra, chúng tôi đã kết
                      hợp tất cả các biện pháp kiểm soát và quy trình cần thiết
                      bắt nguồn từ quy định pháp luật vào Hệ thống quản lý bảo
                      mật thông tin của mình
                    </p>
                  </div>
                  <div className="col-sm-6 panel-box">
                    <div className="text-box"></div>
                    <div className="text-box">
                      <img
                        width="24"
                        height="24"
                        src={ic_oval_lock}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p>
                        Chúng tôi cung cấp cho bạn toàn quyền kiểm soát tất cả
                        dữ liệu của mình và cung cấp các phương tiện để quản lý
                        dữ liệu đó thông qua cả giao diện thân thiện với người
                        dùng và API thân thiện với nhà phát triển.
                      </p>
                    </div>
                    <div className="text-box">
                      <img
                        width="24"
                        height="24"
                        src={ic_oval_lock}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p>
                        Bạn có thể tìm thấy thông tin về những dữ liệu chúng tôi
                        thu thập trong&nbsp;
                        <Link
                          to={
                            language === "vi"
                              ? "/uploads/GoPaperless-ChinhSachBaoMatThongTin"
                              : "/uploads/GoPaperless-InformationSecurityPolicy"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          chính sách bảo mật
                        </Link>
                        . Bạn có thể tìm thấy của chúng tôi&nbsp;
                        <Link
                          to={
                            language === "vi"
                              ? "/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
                              : "/uploads/GoPaperless-PersonalDataCollectionProccessPolicy"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          chính sách thu thập và xử lý dữ liệu cá nhân
                        </Link>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="container pt-50">
              <div className="row text-center">
                <div className="col-sm-10 col-sm-offset-1">
                  <img
                    width="64"
                    height="64"
                    src={ic_outline_group}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold">
                    Các nhà cung cấp dịch vụ được lựa chọn nghiêm ngặt
                  </h2>
                  <p>
                    Chúng tôi chỉ làm việc với những nhà cung cấp dịch vụ mà bảo
                    mật là ưu tiên hàng đầu. Mỗi đối tác kinh doanh của chúng
                    tôi đều được chọn sau một quy trình thẩm định nghiêm ngặt và
                    được Nhóm Bảo mật của chúng tôi giám sát chặt chẽ. Một số
                    đối tác kinh doanh của chúng tôi thay mặt chúng tôi xử lý
                    thông tin của bạn theo Chính sách quyền riêng tư của chúng
                    tôi. Chúng tôi đảm bảo rằng tất cả dữ liệu của chúng tôi sẽ
                    được xử lý trong EU/EEA.
                  </p>
                </div>
                <div className="col-sm-4 logo-box">
                  <img src={skid_solution} alt="" />
                </div>
                <div className="col-sm-4 logo-box">
                  <img src={audkenni} alt="" />
                </div>
                <div className="col-sm-4 logo-box">
                  <img src={amazon} alt="" />
                </div>
                <div className="col-sm-12 mt-20 ">
                  <p className="mx-auto">
                    Bạn có thể tìm thấy những đối tác kinh doanh này trong{" "}
                    <a href="/compliance/list-of-subprocessors" rel="noopener">
                      danh sách các bộ xử lý phụ
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div> */}
          </div>

          {/* <div className="container-fuild bg-primary">
            <div className="container eidas">
              <div className="row pb-16">
                <div className="col-sm-8 col-sm-offset-2 text-center">
                  <img
                    width="64"
                    height="64"
                    src={ic_eidas}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold text-white">
                    Tuân thủ eIDAS
                  </h2>
                  <div className="sub">
                    <p className="text-white">
                      Chữ ký điện tử không phải là những hình ảnh viết nguệch
                      ngoạc trên một tài liệu. Đừng bỏ lỡ cơ hội vì các nhà cung
                      cấp vụng về trên thị trường coi những vấn đề pháp lý liên
                      quan đến tài liệu của bạn là điều hiển nhiên. Tại
                      GoPaperless, chúng tôi coi trọng mọi việc.
                    </p>
                  </div>
                </div>
                <div className="col-sm-6">
                  <img
                    width="41"
                    height="24"
                    src={ic_all_seals}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <p className="text-white">
                    Chúng tôi đã phát triển các dịch vụ của mình ngay từ đầu
                    theo tất cả các yêu cầu kỹ thuật của Quy định (EU) №910/2014
                    (eIDAS). Các dịch vụ của chúng tôi chỉ hoạt động với Chứng
                    chỉ đủ điều kiện, nghĩa là mỗi chữ ký được tạo ra với sự trợ
                    giúp của chúng tôi được liên kết duy nhất và rõ ràng với cả
                    người ký và dữ liệu đã ký. Thực tế là không thể giả mạo chữ
                    ký đó hoặc sử dụng lại nó với một tài liệu khác hoặc được
                    sửa đổi. Ngoài ra, chúng tôi cũng sao lưu từng chữ ký bằng
                    Dấu thời gian đủ điều kiện, do đó cung cấp bằng chứng pháp
                    lý về thời gian chữ ký được tạo.
                  </p>
                </div>
                <div className="col-sm-6">
                  <img
                    width="41"
                    height="24"
                    src={ic_all_seals}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <p className="text-white">
                    Tất cả chữ ký được tạo ra nhờ sự trợ giúp của dịch vụ của
                    chúng tôi đều đáp ứng các yêu cầu về Chữ ký điện tử đủ tiêu
                    chuẩn hoặc Chữ ký điện tử nâng cao được quy định theo quy
                    định eIDAS. Những chữ ký này được chấp nhận trên toàn EU.
                    Chúng tôi làm việc với cơ sở hạ tầng eID ở các quốc gia
                    thành viên EU, đồng thời hỗ trợ và chỉ dựa vào các Nhà cung
                    cấp dịch vụ ủy thác đủ tiêu chuẩn được liệt kê trong Danh
                    sách dịch vụ đáng tin cậy của Liên minh Châu Âu.
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-10 col-lg-offset-1">
                  <div
                    className="row panel-box bg-color-B1D1F5"
                    style={{ border: "none" }}
                  >
                    <div className="col-sm-12 col-md-4 text-center">
                      <img
                        width="120"
                        src={compliance_logo}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <a
                        // onClick={e => {
                        //     window.open(certificate_Biometric, "_blank");
                        //     window.open(certificate_eKYC, "_blank")
                        // }}
                        onClick={openMultiple}
                        className="iso btn-primary btn-primary--mini"
                      >
                        Xem chứng chỉ
                      </a>
                    </div>
                    <div className="col-sm-12 col-md-8">
                      <div className="p-r">
                        <p data-renderer-start-pos="63">
                          GoPaperless là Nhà cung cấp dịch vụ ủy thác đủ điều
                          kiện đầu tiên về xác thực chữ ký điện tử và con dấu
                          điện tử ở vùng Baltic, được giám sát bởi một&nbsp;
                          <a
                            className="sc-bHwgHz ezBJcQ"
                            title="https://www.rrt.lt/en/"
                            href="javascript:;"
                            rel="noopener"
                            data-renderer-mark="true"
                          >
                            Cơ quan giám sát quốc gia thành viên
                          </a>
                          &nbsp;và bao gồm trong&nbsp;
                          <a
                            className="sc-bHwgHz ezBJcQ"
                            title="https://webgate.ec.europa.eu/tl-browser/#/tl/LT/5"
                            href="javascript:;"
                            rel="noopener"
                            data-renderer-mark="true"
                          >
                            Danh sách dịch vụ đáng tin cậy của EU
                          </a>
                          .
                        </p>
                        <p data-renderer-start-pos="265">
                          Tìm hiểu thêm về các biện pháp xác thực và trách nhiệm
                          pháp lý của chúng tôi trong&nbsp;
                          <a
                            className="sc-bHwgHz ezBJcQ"
                            href="javascript:;"
                            rel="noopener"
                            data-renderer-mark="true"
                          >
                            Tuyên bố và Chính sách Thực hành Dịch vụ Xác thực
                            Chữ ký
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="container-fuild bg-color">
            <div className="container service px-md-0">
              <div className="row text-center">
                <div className="col-sm-8 col-sm-offset-2">
                  <img
                    width="64"
                    height="64"
                    src={ic_graphic_eq_gradient}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 className="font-weight-bold">
                    Tính sẵn có của dịch vụ và tính liên tục trong kinh doanh
                  </h2>
                  <p>
                    Chúng tôi có nhiều kinh nghiệm trong việc hỗ trợ các quy
                    trình quan trọng trong kinh doanh và do đó luôn chú ý đến
                    tính sẵn có của dịch vụ. Chúng tôi không ngừng cố gắng cải
                    thiện và đầu tư nhiều nỗ lực để đảm bảo hoạt động kinh doanh
                    của bạn được liên tục, nhưng đừng chỉ tin lời hứa — hãy kiểm
                    tra trạng thái của chúng tôi để tự mình xem chúng tôi đo
                    lường như thế nào.
                  </p>
                </div>
                <div className="col-sm-4">
                  <div className="panel-box bg-white">
                    <img
                      width="30"
                      height="30"
                      src={ic_history}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      Mục tiêu điểm khôi phục (
                      <a href="javascript:;" rel="noopener">
                        RPO
                      </a>
                      )
                    </h4>
                    <p>1 giờ</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="panel-box bg-white">
                    <img
                      width="30"
                      height="30"
                      src={ic_history}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      Mục tiêu thời gian phục hồi (
                      <a href="javascript:;" rel="noopener">
                        RTO
                      </a>
                      )
                    </h4>
                    <p>2 giờ</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="panel-box bg-white">
                    <img
                      width="30"
                      height="30"
                      src={ic_alarm_on}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      Thời gian ngừng hoạt động tối đa
                      <span className="inner">
                        (
                        <a href="javascript:;" rel="noopener">
                          MTPOD
                        </a>
                        )
                      </span>
                    </h4>
                    <p>4 giờ</p>
                  </div>
                </div>

                <div className="container px-md-0">
                  <div className="col-sm-12 panel-box last mt-30 bg-white">
                    <div className="col-sm-4 proved">
                      <img
                        width="30"
                        height="30"
                        src={ic_av_timer}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <h4>Tính khả dụng của dịch vụ đã được chứng minh</h4>
                    </div>
                    <div className="col-sm-4">
                      <p className="sub">
                        <a href="javascript:;">
                          99,95% thời gian hoạt động sẵn có hàng tháng
                        </a>
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img
                        width="331"
                        height="108"
                        src={ic_path}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container mt-80 business">
              <div className="row">
                <div className="col-xs-12 px-md-0">
                  <div className="text-center row">
                    <div className="col-sm-4">
                      <img
                        width="40"
                        height="40"
                        src={ic_enhanced_encryption}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p className="font-weight-bold my-18-12">
                        Mã hóa dữ liệu mạnh mẽ và toàn vẹn dữ liệu
                      </p>
                      <p>
                        Tất cả dữ liệu của chúng tôi được mã hóa bằng thuật toán
                        mã hóa Transport Layer Security (TLS) và AES-256. Tính
                        toàn vẹn dữ liệu được đảm bảo bằng cách sao chép tất cả
                        dữ liệu ở hai vị trí riêng biệt. Trong trường hợp khẩn
                        cấp, dữ liệu và tính toàn vẹn của dữ liệu có thể được
                        khôi phục từ bản sao lưu bằng quy trình tự động. Mục
                        tiêu Điểm khôi phục là 1 giờ.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img
                        width="40"
                        height="40"
                        src={ic_outline_security}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />
                      <p className="font-weight-bold my-18-12">
                        Đội ngũ an ninh chuyên trách
                      </p>
                      <p>
                        Chúng tôi có nhân viên tận tâm để quản lý và giám sát
                        tất cả các dịch vụ và cơ sở hạ tầng của chúng tôi 24/7.
                        Nhóm của chúng tôi có quy trình quản lý sự cố với các kế
                        hoạch dự phòng, cẩm nang ứng phó sự cố và nhiều cấp độ
                        leo thang.
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <img
                        width="40"
                        height="40"
                        src={ic_outline_bug_report}
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                        loading="lazy"
                        data-no-retina=""
                      />{" "}
                      <p className="font-weight-bold my-18-12">
                        Lỗ hổng bảo mật và tiền thưởng lỗi
                      </p>
                      <p>
                        Chúng tôi cam kết áp dụng các biện pháp bảo mật tốt nhất
                        trong ngành. Nếu bạn cho rằng mình đã phát hiện ra lỗ
                        hổng trong dịch vụ của chúng tôi, chúng tôi hoan nghênh
                        sự đóng góp của các nhà nghiên cứu bảo mật bên ngoài và
                        mong muốn trao giải cho họ vì những đóng góp của họ đối
                        với vấn đề bảo mật của tất cả người dùng GoPaperless.
                        Thực hiện theo các nguyên tắc tiết lộ được xác định
                        trong&nbsp;
                        <a href="javascript:;" rel="noopener">
                          Chính sách tiết lộ lỗ hổng bảo mật
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="bg-primary">
            <div className="container insured">
              <div className="row ">
                <div className="col-md-7">
                  <h2 className="font-weight-bold text-white">
                    Bảo hiểm đầy đủ
                  </h2>
                  <div className="sub">
                    <p className="text-white">
                      Chúng tôi được bảo hiểm đầy đủ trước các khoản bồi thường
                      nghề nghiệp, vi phạm quyền riêng tư và các cuộc tấn công
                      mạng lên tới 1 triệu USD. Chúng tôi hy vọng chúng tôi sẽ
                      không phải sử dụng nó nhưng nó chắc chắn sẽ mang lại sự
                      thoải mái hơn cho chúng tôi và khách hàng của chúng tôi.
                      Chúng tôi sẽ duy trì bảo hiểm hợp lệ trong suốt quá trình
                      cung cấp dịch vụ của mình.
                    </p>
                  </div>
                  <a href="javascript:;" className="btn-primary">
                    Xem chứng chỉ
                  </a>
                </div>

                <div className="col-md-5">
                  <img
                    src={require("../../assets/images/pictures/lloyds.png")}
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div> */}

          <div className="bg-bottom-compliance">
            <div className="container pt-50">
              <div className="row">
                <div className="col-sm-5 px-md-0">
                  <img src={group} className="img-responsive" alt="" />
                </div>
                <div className="col-sm-7 pl-md-70">
                  <h2 className="heading font-weight-bold pb-22">
                    Cách chọn nhà cung cấp giải pháp chữ ký điện tử
                  </h2>
                  <p>
                    Khi ủy thác các tài liệu của công ty bạn cho các đối tác, dù
                    là bộ phận hay toàn công ty, không chỉ phần trực tiếp của
                    quy trình ký kết mới là vấn đề quan trọng; mọi thứ ở phía
                    sau – việc tuân thủ các quy định, trình độ dịch vụ, bảo mật
                    thông tin, hiệu lực chữ ký thực tế – có thể tạo nên sự khác
                    biệt trên thế giới.
                  </p>
                  <p className="pb-16">
                    Hãy cẩn thận với người mà bạn giao dữ liệu của mình và lưu ý
                    đừng chỉ đưa ra những tuyên bố mơ hồ và tuân thủ được cho là
                    đã tuyên bố. Tải xuống danh sách kiểm tra để hướng dẫn bạn
                    những khía cạnh quan trọng nhất của việc chọn nhà cung cấp
                    giải pháp chữ ký điện tử.
                  </p>
                  <a href="javascript:;" className="btn-secondary">
                    Tải xuống danh sách kiểm tra
                  </a>
                </div>
              </div>
            </div>

            <div className="container legal">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <img
                    width="64"
                    height="64"
                    src={ic_hammer}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h2 id="legal" className="font-weight-bold">
                    Hợp pháp
                  </h2>
                </div>
                <div className="col-sm-12 px-md-0">
                  <ul className="panel-box--list">
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Cảnh báo thu hồi chia sẻ thông tin từ VNeID</span>

                      <div className="dropdown" id="openTermsOfService">
                        <a
                          href="javascript:;"
                          className="mr-32"
                          onClick={handleOpenTermOfService}
                          id="dropdownMenuLinkTerms"
                        >
                          {openTerms === false ? (
                            <img src={ic_plus} alt="" />
                          ) : (
                            <img src={ic_sub} alt="" className="mr--5" />
                          )}
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuLinkTerms"
                        >
                          <Link
                            to={
                              language === "vi"
                                ? "/uploads/GoPaperless-CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeID"
                                : "/uploads/GoPaperless-WarningDataSharingFromVNeID"
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="dropdown-item"
                          >
                            Tài liệu gốc
                          </Link>
                          {/* <a href="/compliance/terms-of-service" className="dropdown-item" target="_blank"
                                                        >Dịch thuật tiếng Việt</a> */}
                        </div>
                      </div>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Chính sách bảo mật thông tin</span>

                      <div className="dropdown" id="openPrivacyPolicy">
                        <a
                          href="javascript:;"
                          className="mr-32"
                          onClick={handleOpenPrivacyPolicy}
                          id="dropdownMenuLinkTerms"
                        >
                          {openPrivacy === false ? (
                            <img src={ic_plus} alt="" />
                          ) : (
                            <img src={ic_sub} alt="" className="mr--5" />
                          )}
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuLinkTerms"
                        >
                          <Link
                            to={
                              language === "vi"
                                ? "/uploads/GoPaperless-ChinhSachBaoMatThongTin"
                                : "/uploads/GoPaperless-InformationSecurityPolicy"
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="dropdown-item"
                          >
                            Tài liệu gốc
                          </Link>
                          {/* <a href="javascript:;" className="dropdown-item"  >Dịch thuật tiếng Việt</a> */}
                        </div>
                      </div>
                    </li>

                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Chính sách thu thập và xử lý dữ liệu cá nhân</span>

                      <div className="dropdown" id="openDPA">
                        <a
                          href="javascript:;"
                          className="mr-32"
                          onClick={handleOpenDPA}
                          id="dropdownMenuLinkTerms"
                        >
                          {openDPA === false ? (
                            <img src={ic_plus} alt="" />
                          ) : (
                            <img src={ic_sub} alt="" className="mr--5" />
                          )}
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuLinkTerms"
                        >
                          <Link
                            to={
                              language === "vi"
                                ? "/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
                                : "/uploads/GoPaperless-PersonalDataCollectionProccessPolicy"
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="dropdown-item"
                          >
                            Tài liệu gốc
                          </Link>
                          {/* <a href="javascript:;" className="dropdown-item"  >Dịch thuật tiếng Việt</a> */}
                        </div>
                      </div>
                    </li>
                    {/* <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Chính sách Cookie</span>
                      <a
                        className="mr-32"
                        href="/compliance/cookie-policy"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li> */}
                    {/* <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Hiệp định hợp tác</span>
                      <a
                        className="mr-32"
                        href="/compliance/partnership-agreement"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Danh sách các bộ xử lý phụ</span>
                      <a
                        className="mr-32"
                        href="/compliance/list-of-subprocessors"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Chính sách tiết lộ lỗ hổng bảo mật</span>
                      <a
                        className="mr-32"
                        href="/compliance/vulnerability-disclosure-policy"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>Giải quyết tranh chấp</span>
                      <a
                        className="mr-32"
                        href="/compliance/dispute-resolution"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li>
                    <li className="panel-box panel-box__terms border-bottom-0033AD">
                      <span>
                        Tuyên bố và Chính sách Thực hành Dịch vụ Xác thực Chữ ký
                      </span>
                      <a
                        className="mr-32"
                        href="/compliance/signature-validation-service-practice-statement-and-policy"
                        target="_blank"
                      >
                        <img src={ic_arrow_left} alt="" />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            <div className="border-bottom bg-color p-0">
              <div className="container">
                <div className="row isign-apis">
                  <div className="col-md-5 ">
                    <h2 className="text-get-started">Sẵn sàng để bắt đầu?</h2>
                    <h4 className="text-p">
                      Đã là người dùng GoPaperless?{" "}
                      <a
                        href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                          i18n.language || "vi"
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        className="underline"
                      >
                        Đăng nhập
                      </a>
                    </h4>
                  </div>
                  <div className="col-sm-12 col-md-7">
                    <div className="btn-box">
                      <a
                        href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                          i18n.language || "vi"
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-secondary"
                      >
                        Bắt đầu ký - hoàn toàn miễn phí
                      </a>
                      <a href="/features" className="btn-primary ">
                        Tại sao GoPaperless?
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default ComplianceContent;
